import PropTypes from "prop-types";
import React, { Component } from "react";
import "./styles.scss";
import "react-table-v6/react-table.css";
import selectTableHOC from "react-table/lib/hoc/selectTable";
import PropTypes from "prop-types";
import Table from "react-table";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import duplicateImg from "signoxe/images/duplicate.png";
import editImg from "signoxe/images/edit.png";
import previewImg from "signoxe/images/preview.png";
import { Link } from "react-router-dom/es";

const SelectTable = selectTableHOC(Table);

class PlaylistList extends Component {
  static defaultProps = {
    keyField: "id",
  };

  static propTypes = {
    keyField: PropTypes.string,
  };

  static propTypes = {
    handleToggleAll: PropTypes.func.isRequired,
    handleDeletePlaylist: PropTypes.func.isRequired,
    handleClonePlaylist: PropTypes.func.isRequired,
    onToggleEdit: PropTypes.func.isRequired,
    renderEditable: PropTypes.func.isRequired,
    refKey: PropTypes.func.isRequired,
    playlists: PropTypes.array.isRequired,
    filteredResults: PropTypes.array.isRequired,
    selectAll: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    tableProps: PropTypes.array.isRequired,
    toggleSelection: PropTypes.array.isRequired,
    editing: PropTypes.array.isRequired,
    checkedIsSelected: PropTypes.bool.isRequired,
    listPlaylistTags: PropTypes.array.isRequired,

  };

  render() {
    const {
      toggleSelection,
      handleToggleAll,
      handleDeletePlaylist,
      refKey,
      checkedIsSelected,
      tableProps,
      renderEditable,
      listPlaylistTags,
      handleClonePlaylist,
      onToggleEdit,
    } = this.props;

    const {
      playlists,
      isLoading,
      selectAll,
      editing,
    } = this.props;
    const defaultColumns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "name",
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> No of Items{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          maxWidth: "content",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Tags{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },

      {
        Header: () => <div></div>,
        sortable: false,
        filterable: false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },
    ];

    const columns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },

        accessor: "name",
        Cell: renderEditable,

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> No of Items{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "items_count",

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => (
          <div className="hide-for-mobile">
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Tags{" "}
          </div>
        ),
        // sortable: true,
        // filterable: true,
        accessor: "listags[0].name",

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
        Cell: (props) => listPlaylistTags(props.original),
      },

      {
        Header: () => <div></div>,
        sortable: false,
        filterable: false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        style: {
          textAlign: "right",
          border: "1px solid transparent",
        },

        Cell: (props) => {
          return (
            <div class="d-flex align-items-center">
              <span
                title="Create a Clone"
                className="custom-icon mr-1"
                onClick={() => {
                  handleClonePlaylist(props.original);
                }}
              >
                {" "}
                <img
                  src={duplicateImg}
                  alt="..."
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  className="action-icon"
                />
              </span>
              <span
                title="Edit Playlist"
                className="custom-icon"
                onClick={onToggleEdit}
              >
                {" "}
                <img
                  src={editImg}
                  alt="..."
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  className="action-icon"
                />
              </span>
              <span title="Preview">
                <Link
                  className="custom-icon"
                  to={`/preview/${props.original.id}/`}
                >
                  <img
                    src={previewImg}
                    alt=".."
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      width: "auto",
                    }}
                    className="action-icon"
                  />
                </Link>
              </span>
              <span
                title="Delete"
                className="custom-icon mr-1"
                onClick={() => {
                  handleDeletePlaylist(props.original);
                }}
              >
                <i className="fas fa-trash-o"></i>
              </span>
            </div>
          );
        },
      },
    ];
    const mobileColumns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "name",
        Cell: renderEditable,

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Items{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "items_count",

        style: {
          textAlign: "center",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => <div></div>,
        sortable: false,
        filterable: false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        style: {
          textAlign: "right",
          border: "1px solid transparent",
        },

        Cell: (props) => {
          return (
            <div class="d-flex align-items-center">
              <span
                title="Edit Playlist"
                className="custom-icon"
                onClick={onToggleEdit}
              >
                {" "}
                <img
                  src={editImg}
                  alt="Edit Icon"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  className="action-icon"
                />
              </span>
              <span
                title="Create a Clone"
                className="custom-icon mr-1"
                onClick={() => {
                  handleClonePlaylist(props.original);
                }}
              >
                <img
                  src={duplicateImg}
                  alt="..."
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  className="action-icon"
                />
              </span>
              <span
                title="Delete"
                className="custom-icon mr-1"
                onClick={() => {
                  handleDeletePlaylist(props.original);
                }}
              >
                <i className="fas fa-trash-o"></i>
              </span>
            </div>
          );
        },
      },
    ];
    return (
      <React.Fragment>
        {playlists && playlists.length === 0 ? (
          <ReactTable
            columns={defaultColumns}
            defaultPageSize={3}
            noDataText={"Loading Playlists .."}
            loading={isLoading}
            showPagination={false}
          />
        ) : (
          <div>
            <div className="hide-for-desktop">
              {editing ? (
                <SelectTable
                  keyField="id"
                  columns={mobileColumns}
                  data={playlists}
                  defaultPageSize={10}
                  noDataText={"Loading Playlists .."}
                  loading={isLoading}
                  ref={refKey}
                  toggleSelection={toggleSelection}
                  selectAll={selectAll}
                  selectType="checkbox"
                  toggleAll={handleToggleAll}
                  isSelected={checkedIsSelected}
                  getTrProps={tableProps}
                />
              ) : (
                <ReactTable
                  columns={mobileColumns}
                  data={playlists}
                  defaultPageSize={10}
                  noDataText={"Loading Playlists .."}
                  loading={isLoading}
                />
              )}
            </div>

            <div className="hide-for-mobile">
              {editing ? (
                <SelectTable
                  keyField="id"
                  columns={columns}
                  data={playlists}
                  defaultPageSize={10}
                  noDataText={"Loading Playlists .."}
                  loading={isLoading}
                  ref={refKey}
                  toggleSelection={toggleSelection}
                  selectAll={selectAll}
                  selectType="checkbox"
                  toggleAll={handleToggleAll}
                  isSelected={checkedIsSelected}
                  getTrProps={tableProps}
                />
              ) : (
                <ReactTable
                  columns={columns}
                  data={playlists}
                  defaultPageSize={10}
                  noDataText={"Loading Playlists .."}
                  loading={isLoading}
                />
              )}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

PlaylistList.propTypes = {
  playlists: PropTypes.array.isRequired,
  handleToggleAll: PropTypes.func.isRequired,
  checkedIsSelected: PropTypes.func.isRequired,
  tableProps: PropTypes.func.isRequired,
  isLoading: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  filteredResults: PropTypes.func.isRequired,
  selectAll: PropTypes.func.isRequired,
  refKey: PropTypes.func.isRequired,
  toggleSelection: PropTypes.func.isRequired,
  columns: PropTypes.func.isRequired,
  editing: PropTypes.func.isRequired,
};

export default PlaylistList;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PlaylistList/index.js